module.exports = __webpack_public_path__ + "static/media/card-mini.5e0da510.png";